<template>
  <span v-if="!isPooqzone" class="check-time" @click.prevent="toggle()" @keypress.enter="toggle()">
    <input type="checkbox" :id="'ch-time' + index" v-model="isChecked">
    <label :for="'ch-time' + index">
      <span class="a11y-hidden">시청예약</span>
      <span v-if="hasTitle">시청예약</span>
    </label>
  </span>
</template>

<script>
import { commonErrorProcess } from '@/common/utils/common'
import { postAlarmsContent, deleteAlarmsContent, postZzimBaseball, deleteZzimBaseball } from '@/common/utils/request'
import cookie from '@/common/utils/cookie'
import constant from '@/common/resources/constant'
import { showLoginPopup } from '@/common/utils/scalable.player'
import _ from 'lodash'
export default {
  props: {
    index: {
      type: Number,
      default: 0
    },
    isOn: {
      type: String,
      required: true
    },
    contentsId: {
      type: String,
      required: true
    },
    targetDate: {
      type: String,
      required: true
    },
    programId: {
      type: String
    },
    contentType: {
      type: String
    },
    gameId: {
      type: String
    },
    contentTitle: {
      type: String
    },
    hasTitle: {
      type: Boolean,
      defaultValue: false
    }
  },
  data () {
    return {
      isPooqzone: cookie.isWavveOn(),
      isChecked: false
    }
  },
  methods: {
    toggle () {
      if (cookie.getCredential() === 'none') {
        showLoginPopup()
        return
      }
      let registAlarmApi, deleteAlarmApi
      if (!this.isChecked) {
        if (confirm(constant.MSG_ASK_ADD_LIVE_ALARM)) {
          if (this.contentType === 'baseball_live') {
            registAlarmApi = postZzimBaseball({ alarmtype: this.contentType, gameid: this.gameid, contentid: this.contentsId, image: '', contenttitle: this.contentTitle, channeltitle: '', releasedatetime: this.targetDate })
          } else {
            registAlarmApi = postAlarmsContent({ alarmtype: 'live', contentid: this.contentsId, releasedatetime: this.targetDate, programid: this.programId })
          }
          registAlarmApi.then(({ data }) => {
            if (_.get(data, 'resultcode', '') === '200' && _.get(data, 'resultmessage', '') === 'success') {
              this.isChecked = true
              alert(constant.MSG_COMPLETE_ADD_LIVE_ALARM)
            }
          }).catch(commonErrorProcess)
        }
      } else {
        if (confirm(constant.MSG_ASK_DELETE_LIVE_ALARM)) {
          if (this.contentType === 'baseball_live') {
            deleteAlarmApi = deleteZzimBaseball({ alarmtype: this.contentType, contentid: this.contentsId, releasedatetime: this.targetDate })
          } else {
            deleteAlarmApi = deleteAlarmsContent({ alarmtype: 'live', contentid: this.contentsId, releasedatetime: this.targetDate })
          }
          deleteAlarmApi.then(({ data }) => {
            if (_.get(data, 'resultcode', '') === '200' && _.get(data, 'resultmessage', '') === 'success') {
              this.isChecked = false
              alert(constant.MSG_COMPLETE_DELETE_LIVE_ALARM)
            }
          }).catch(commonErrorProcess)
        }
      }
    }
  },
  mounted () {
    this.isChecked = this.isOn === 'y'
  }
}
</script>
